import React, { useContext } from 'react';
import { Pause } from '@styled-icons/boxicons-regular/Pause';
import TimerContext from '~/context/timerContext';

import { Button } from './styles';

const StopButton = () => {
  const timerContext = useContext(TimerContext);
  const { setTimerRunning, timerRunning } = timerContext;

  return (
    <Button
      type="button"
      className={`${!timerRunning ? 'active' : ''}`}
      onClick={() => setTimerRunning(false)}
    >
      <Pause />
    </Button>
  );
};

export default StopButton;
